(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Toast from "react-bootstrap/Toast";
import Axios from "axios";
import { ReCaptcha, loadReCaptcha } from "react-recaptcha-v3";
import utilities, { EMAIL_CONTACT, NAME_COMPANY } from "../utils/utilities";
import { createBodyEmail, sendEmail } from "../utils/apiEmails";
const initialState = {
  name: "",
  email: "",
  phone: "",
  message: "",
  token: "",
  sendInformation: false
};

class FormContact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validated: false,
      success: false,
      form: { ...initialState
      },
      loading: false,
      error: false,
      captcha: true
    };
    this.isLoadedRecaptcha = false;
    this.recaptchaRef = /*#__PURE__*/React.createRef();
    this.formRef = /*#__PURE__*/React.createRef();
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleChangeCaptcha = this.handleChangeCaptcha.bind(this);
    this.onCaptchaExpired = this.onCaptchaExpired.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    this.updateToken = this.updateToken.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateField = this.validateField.bind(this);
    this.loadCaptcha = this.loadCaptcha.bind(this);
  }

  verifyCallback(token) {
    // console.log('token', token);
    const {
      form
    } = this.state;
    this.setState({
      form: { ...form,
        token,
        captcha: !!token
      }
    });
  }

  loadCaptcha() {
    if (!this.isLoadedRecaptcha) {
      loadReCaptcha(utilities.recaptcha.PUBLIC_KEY, res => console.log("loadReCaptcha", res));
      this.isLoadedRecaptcha = true;
    }
  }

  updateToken() {
    this.recaptchaRef.execute();
  }

  handleChange(event) {
    const {
      form
    } = this.state; // console.log('event', event);

    this.setState({
      form: { ...form,
        [event.target.name]: event.target.files ? event.target.files : event.target.value
      }
    });
    this.loadCaptcha();
  }

  handleCheckChange(event) {
    const {
      form
    } = this.state;
    this.setState({
      form: { ...form,
        [event.target.name]: event.target.checked
      }
    });
  }

  handleChangeRadio(value) {
    // console.log('handleChangeRadio');
    const {
      form
    } = this.state; // console.log('event', event);

    this.setState({
      form: { ...form,
        sendInformation: value
      }
    });
  }

  handleChangeCaptcha(value) {
    console.log("Captcha value:", value);
    this.state.setState({
      captcha: true
    });
  }

  onCaptchaExpired() {
    this.state.setState({
      captcha: false
    });
  }

  handleSubmit(event) {
    this.loadCaptcha();
    const formControl = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    const {
      form
    } = this.state;
    const {
      token
    } = form; // console.log('formControl.checkValidity() :>> ', formControl);
    // const token = this.recaptchaRef.current.getValue();

    if (!token) {
      console.log("token :>> ", token);
      this.updateToken();
      this.setState({
        captcha: false,
        validated: true
      });
    } else if (formControl.checkValidity() !== false) {
      this.setState({
        loading: true
      });

      try {
        let clientEmail = EMAIL_CONTACT;
        const fullName = `${form.name}`;
        const formName = 'Form Contact';
        const subjectEmail = `${fullName} - ${formName}`;
        const body = createBodyEmail(`${fullName}`, form.email, form.phone, form.message, form.sendInformation); //Our Client

        sendEmail(`${fullName}`, clientEmail, form.email, `${NAME_COMPANY} -` + subjectEmail, body, 'https://thedistrictusc.com/contact'); //User who filled the form
        // sendEmail(`${fullName}`, form.email, clientEmail, `${NAME_COMPANY} -` + subjectEmail + " (Confirmation Email)", body, true);
      } catch (error) {
        console.log('error', error);
      }

      this.formRef.reset();
      this.setState({
        success: true,
        loading: false,
        validated: false,
        form: { ...initialState
        }
      }); //   } else {
      //     console.log("data", data);
      //     this.setState({ error: true, loading: false });
      //   }
      // })
      // .catch(err => {
      //   console.log("err", err);
      //   this.setState({ error: true, loading: false });
      //   this.updateToken();
      // });
      // } catch (err) {
      //   this.setState({ error: true });
      // }
    } else {
      console.log("validated");
      this.setState({
        validated: true
      });
    }
  }

  validateField(name) {
    if (this.state.validated) {
      return this.formRef[name].checkValidity();
    }

    return true;
  }
  /* componentDidMount() {
    this.loadCaptcha();
  } */


  render() {
    return /*#__PURE__*/React.createElement(Form, {
      noValidate: true,
      validated: this.state.validated,
      onSubmit: this.handleSubmit,
      action: "/",
      ref: ref => {
        this.formRef = ref;
      }
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, /*#__PURE__*/React.createElement(Form.Group, {
      controlId: "name"
    }, /*#__PURE__*/React.createElement(Form.Label, null, "Full Name"), /*#__PURE__*/React.createElement(Form.Control, {
      type: "text",
      maxLength: "30",
      name: "name",
      onChange: this.handleChange,
      required: true
    }), /*#__PURE__*/React.createElement(Form.Control.Feedback, null, "Looks good!"), /*#__PURE__*/React.createElement(Form.Control.Feedback, {
      type: "invalid"
    }, "Please provide your full name"))), /*#__PURE__*/React.createElement(Col, {
      md: 6
    }, /*#__PURE__*/React.createElement(Form.Group, {
      controlId: "email"
    }, /*#__PURE__*/React.createElement(Form.Label, null, "Email"), /*#__PURE__*/React.createElement(Form.Control, {
      name: "email",
      onChange: this.handleChange,
      type: "email",
      maxLength: "50",
      required: true
    }), /*#__PURE__*/React.createElement(Form.Control.Feedback, null, "Looks good!"), /*#__PURE__*/React.createElement(Form.Control.Feedback, {
      type: "invalid"
    }, "Please provide a valid email")))), /*#__PURE__*/React.createElement(Form.Group, {
      controlId: "phone"
    }, /*#__PURE__*/React.createElement(Form.Label, null, "Telephone"), /*#__PURE__*/React.createElement(Form.Control, {
      type: "tel",
      name: "phone",
      maxLength: "20",
      onChange: this.handleChange,
      required: true
    }), /*#__PURE__*/React.createElement(Form.Control.Feedback, null, "Looks good!"), /*#__PURE__*/React.createElement(Form.Control.Feedback, {
      type: "invalid"
    }, "Please provide a valid telephone")), /*#__PURE__*/React.createElement(Form.Group, {
      controlId: "message",
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(Form.Label, null, "Message"), /*#__PURE__*/React.createElement(Form.Control, {
      name: "message",
      as: "textarea",
      rows: "5",
      maxLength: "500",
      onChange: this.handleChange,
      required: true,
      style: {
        height: "99px"
      }
    }), /*#__PURE__*/React.createElement(Form.Control.Feedback, null, "Looks good!"), /*#__PURE__*/React.createElement(Form.Control.Feedback, {
      type: "invalid"
    }, "Please type your message")), /*#__PURE__*/React.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/React.createElement(ReCaptcha, {
      ref: ref => {
        this.recaptchaRef = ref;
      },
      sitekey: utilities.recaptcha.PUBLIC_KEY,
      action: "submit",
      verifyCallback: this.verifyCallback
    }), !this.state.captcha && /*#__PURE__*/React.createElement("span", {
      className: "invalid-feedback d-block sr-only"
    }, "Invalid Captcha!")), /*#__PURE__*/React.createElement("p", {
      className: "mb-4 text-center",
      disabled: this.state.loading
    }, /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      variant: "secondary"
    }, "Send Message")), this.state.success && /*#__PURE__*/React.createElement("div", {
      "aria-live": "polite",
      "aria-atomic": "true",
      className: "d-flex justify-content-center align-items-center parentoasts"
    }, /*#__PURE__*/React.createElement(Toast, {
      onClose: () => this.setState({
        success: false
      }),
      show: this.state.success,
      delay: 5000,
      autohide: true
    }, /*#__PURE__*/React.createElement(Toast.Header, null, /*#__PURE__*/React.createElement("strong", {
      className: "mr-auto"
    }, "THE DISTRICT")), /*#__PURE__*/React.createElement(Toast.Body, {
      className: "alert-success"
    }, "We have received your request, in a moment you will receive a confirmation email. Thank you!"))));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = FormContact;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(initialState, "initialState", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/form-contact.jsx");
  reactHotLoader.register(FormContact, "FormContact", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/form-contact.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/form-contact.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();